import { Card, CardContent, Skeleton, Stack } from '@mui/material'
import React from 'react'
import { SkeletonText } from 'utoniq-ui'

import { Cell } from '@/core/architecture'

type MissionBoxSkeletonProps = {
  fullWidth?: boolean
}

export const MissionBoxSkeleton: Cell<MissionBoxSkeletonProps> = ({
  fullWidth,
}) => (
  <Card sx={{ borderRadius: 2, width: fullWidth ? '100%' : 315 }}>
    <CardContent>
      <Stack direction="row" spacing={4}>
        <Stack flex={1}>
          <SkeletonText variant="medium" width="50%" />
          <SkeletonText variant="small" />
        </Stack>
        <Skeleton variant="rectangular" width={48} height={76} />
      </Stack>
    </CardContent>
  </Card>
)
